import { createFileRoute } from "@tanstack/react-router";
import HistorySharePage, {
  historyValidateSearch,
} from "../-share_pages/history/index";

export const Route = createFileRoute("/template_protections/history/received")({
  validateSearch: historyValidateSearch,
  component: ReceivedHistoryPage,
});

function ReceivedHistoryPage() {
  return (
    <HistorySharePage
      type="recive"
      routeId="/template_protections/history/received"
    />
  );
}
